import { useListSalesExecutivesForAccountQuery } from "@generated";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";
import { useEffect, useState } from "react";
import { SalesExecutive } from "../types";
import { generated } from "@generated";
import { AppDispatch } from "@store/*";

const useGetAllSalesExecutives = () => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);
  const dispatch = useDispatch<AppDispatch>();
  const { data, isLoading, error } = useListSalesExecutivesForAccountQuery({
    slug: accountSlug,
    page: {},
  });
  const [executives, setExecutives] = useState<SalesExecutive[]>([]);
  const [loading, setLoading] = useState(isLoading);

  useEffect(() => {
    if (!isLoading && data && data.data && data.meta && !error) {
      setExecutives(
        data.data.map((exec) => ({
          id: exec.id?.toString() || "",
          name: exec.attributes.name,
        }))
      );
      const pageCount = data.meta["page-count"] || 1;

      if (pageCount > 1) {
        setLoading(true);
        const fetchPages = async () => {
          try {
            for (let page = 2; page <= pageCount; page++) {
              // Trigger additional fetches for each page
              const resultAction = await dispatch(
                generated.endpoints.listSalesExecutivesForAccount.initiate({
                  slug: accountSlug,
                  page: {
                    number: page,
                  },
                })
              ).unwrap(); // Assuming this is where the 'unwrap()' method is now chained

              // Check if resultAction.data exists and is an array before mapping
              if (resultAction.data && Array.isArray(resultAction.data)) {
                setExecutives((prevExecutives) => [
                  ...prevExecutives,
                  ...resultAction.data!.map((exec) => ({
                    id: exec.id?.toString() || "",
                    name: exec.attributes.name,
                  })),
                ]);
              }
            }
          } catch (err) {
            console.error("Failed to fetch additional pages:", err);
          } finally {
            setLoading(false);
          }
        };

        fetchPages();
      }
    }
  }, [data, isLoading, error, accountSlug, dispatch]);

  return { executives, loading, error };
};

export default useGetAllSalesExecutives;
